import styled from 'styled-components'

export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
`

// The gap is a margin, not a trailing space: this is a flex child of
// CardTitleRow, and a block strips trailing whitespace from its last line.
export const ModelPrefix = styled.span`
  color: #9ca3af;
  font-weight: 400;
  margin-right: 4px;
`

export const Title = styled.span`
  font-weight: 500;
  color: #374151;
  font-size: 14px;
`

export const OperatorText = styled.span`
  color: #6b7280;
  font-size: 12px;
  padding: 4px 8px;
  white-space: nowrap;
  flex-shrink: 0;
`

export const ValueText = styled.span`
  color: #374151;
  font-size: 12px;
  padding: 4px 8px;
`
